export default __webpack_public_path__ + "20ec9de7f52ad8d2245c2758f6fd5ca4.svg";